/**
 * User submissions API client wrapping the backend /users/:userId/submissions
 * endpoint. Fetches a paginated list of the user's own submissions (with
 * their bounties), optionally filtered by submission status.
 * Consumed by ItemCollection.
 */
import { PaginatedResponse } from "@/types/pagination";
import { SubmissionStatus, SubmissionWithBounty } from "@/types/submission";
import { fetchPaginatedItems } from "./paginated";
export interface UserSubmissionQueryParams {
    page?: number;
    perPage?: number;
    status?: SubmissionStatus;
}

const UserSubmissionAPI = {
    fetchUserSubmissions: async (
        userId: number,
        params: UserSubmissionQueryParams = {}
    ): Promise<PaginatedResponse<SubmissionWithBounty>> => {
        return fetchPaginatedItems<SubmissionWithBounty>(`/users/${userId}/submissions`, params);
    },
};

export default UserSubmissionAPI;
